var map = {
	"./ar.json": "af08",
	"./de.json": "6ce2",
	"./en.json": "edd4",
	"./es.json": "a306",
	"./fi.json": "5754",
	"./fr.json": "f693",
	"./it.json": "0825",
	"./ja.json": "0423",
	"./localazy/en.json": "d412",
	"./localazy/ja.json": "198b",
	"./localazy/ru.json": "e079",
	"./nl.json": "a625",
	"./pt.json": "5d67",
	"./ru.json": "7704",
	"./sv.json": "4c5b",
	"./zh_cn.json": "eadb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "49f8";